module.exports = Object.freeze({
  OPERATOR: 'operator',
  SUPERVISOR: 'supervisor',
  MAINTENANCE: 'maintenance',
  MANAGEMENT: 'management',
  ADMIN: 'admin'
});